import {$app} from '../app'
import Query from '../app/Query'

export async function getActiveRewards (limit = 10, offset = 0) {

  const {total_items, vouchers: rewards} = await $app.$api({
    action: 'carecloud_user_api',
    route: (new Query("vouchers"))
      .add('sort_field', 'valid_to')
      .add('sort_direction', 'asc')
      .add('is_valid', true)
      .add('count', limit)
      .add('offset', offset).route
  })


  return {total_items, rewards}
}

export async function getAppliedRewards (limit = 10, offset = 0) {

  const {total_items, vouchers: rewards} = await $app.$api({
    action: 'carecloud_user_api',
    route: (new Query("vouchers"))
      .add('sort_field', 'valid_to')
      .add('sort_direction', 'desc')
      .add('is_applied', true)
      .add('count', limit)
      .add('offset', offset).route
  })


  return {total_items, rewards}
}

